import styled from 'styled-components'
import { styleSystem } from "../../../../toolkit/styleSystem";
import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/vsDark";

const StyledcodeHighlight = styled.div`
  ${styleSystem()}
`;

const CodeHighlight = ({children, language,...props}) => {
  return <StyledcodeHighlight {...props}>
    <Highlight
      {...defaultProps}
      theme={theme}
      code={children.trim()}
      language={language}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={className} style={{ ...style, padding: "20px" }}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line, key: i })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>

  </StyledcodeHighlight>
}

export default CodeHighlight